exports.IDS = {
  // IMG_URL: "http://192.168.16.56:4328",
  // IMG_URL: "https://gravitydrive.newnode.profcyma.org:4328",
  IMG_URL: "https://node.gravitydrive.in:4328",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  AppSetUp: 1,
  Roles: {
    SuperAdmin: 1,
    Admin: 2,
    ServiceCenter: 3,
    Ambassador: 4,
  },
  AccountStatus: {
    Block: 1,
    Unblock: 2,
  },
  VerificationStatus: {
    Verified: 1,
    Unverified: 2,
  },
  ServiceType: {
    Pickup: 1,
    Drop: 2,
  },
  Type: {
    Debit: 1,
    Credit: 2,
  },
  TransactionType: {
    PickUp: 1,
    Drop: 2,
    Withdrawal: 3,
  },
  PickupDropStatus: {
    New: 1,
    Assigned: 2,
    Cancelled: 3,
    OngoingtoServiceCenter: 4,
    OngoingtoCustomer: 5,
    Completed: 6,
  },
  PaymentStatus: {
    Unpaid: 1,
    Paid: 2,
  },
  Policy: {
    AboutUs: 1,
    TermsAndConditions: 1,
    PrivacyPolicy: 1,
    Faqs: 1,
  },
  WithdrawStatus: {
    Processing: 1,
    Accepted: 2,
    Rejected: 3,
  },
};
